import { createSelector, createSlice } from '@reduxjs/toolkit';
import { loadLocalDraft } from '../apis/localDrafts';
import { loadProject } from '../apis/projects/loadProject';
import { PdpState } from '../store';

type LoadStatus = 'pending' | 'error' | 'ready';

export const { actions, reducer } = createSlice({

    name: 'snapshot',

    initialState: {
        loadStatus: 'ready' as LoadStatus,
        snapshotIds: [] as string[]
    },

    reducers: {},

    extraReducers: builder => {
        for (const loader of [loadProject, loadLocalDraft]) {
            builder
                .addCase(loader.pending, state => void (state.loadStatus = 'pending'))
                .addCase(loader.rejected, state => void (state.loadStatus = 'error'))
                .addCase(loader.fulfilled, state => void (state.loadStatus = 'ready'));
        }
    }
});

export const selectIsLoadingProject = createSelector([
    (state: PdpState) => state.projectLoading.loadStatus
], loadStatus => {
    return loadStatus === 'pending';
});

export const selectHasLoadError = createSelector([
    (state: PdpState) => state.projectLoading.loadStatus
], loadStatus => {
    return loadStatus === 'error';
});